import Layout from "../components/Layout";
import { Scale } from "lucide-react";

const SECTIONS = [
  {
    title: "Titular",
    paragraphs: ["El sitio web relevo.global y la plataforma Relevo son operados por:"],
    dl: [
      ["Titular", "Ariza Santiago Wealth Solutions, S.L."],
      ["NIF", "B72350325"],
      ["Domicilio de contacto", "Paseo de la Castellana 200, 28046 Madrid"],
      ["Correo electrónico", "info@mascorporate.net"],
      ["Datos registrales", "Inscrita en el Registro Mercantil de Cádiz, Tomo 2268, Folio 39, Sección 8, Hoja CA-52956."],
    ],
  },
  {
    title: "Objeto",
    paragraphs: [
      "Relevo es una plataforma tecnológica orientada a facilitar el contacto y desarrollo de potenciales operaciones corporativas entre vendedores de empresas, searchers, compradores e inversores profesionales.",
      "Cuando se formalice el correspondiente mandato, Relevo podrá asimismo prestar servicios de asesoramiento M&A al Vendedor.",
    ],
  },
  {
    title: "Servicios profesionales",
    paragraphs: [
      "La información disponible en la web tiene carácter general y no constituye asesoramiento jurídico, fiscal o de inversión.",
      "El acceso a Relevo no garantiza la realización de una operación ni la obtención de financiación o inversión.",
    ],
  },
  {
    title: "Propiedad intelectual",
    paragraphs: [
      "Los contenidos, marca, diseño, software, estructura y demás elementos de Relevo pertenecen a Ariza Santiago Wealth Solutions, S.L. o se utilizan con las correspondientes autorizaciones.",
      "No podrán reproducirse, explotar o utilizarse fuera de los usos permitidos por la plataforma sin autorización.",
    ],
  },
  {
    title: "Responsabilidad",
    paragraphs: [
      "Relevo procura mantener la información y servicios disponibles de forma correcta y segura, pero no puede garantizar la ausencia absoluta de errores, interrupciones o contenidos incorrectos aportados por terceros.",
      "Cada usuario será responsable de verificar la información relevante antes de adoptar decisiones empresariales, financieras o jurídicas.",
    ],
  },
  {
    title: "Enlaces",
    paragraphs: [
      "Relevo puede contener enlaces a servicios de terceros. La existencia de dichos enlaces no implica que Relevo controle o responda de dichos servicios.",
    ],
  },
  {
    title: "Legislación",
    paragraphs: [
      "El sitio y sus servicios se rigen por la legislación española, sin perjuicio de las normas específicas contenidas en los contratos que se formalicen a través de la plataforma.",
    ],
  },
];

export default function LegalNotice() {
  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-6 lg:px-10 py-12 lg:py-20" data-testid="legal-notice-page">
        <div className="mb-12 fade-up">
          <span className="font-mono-label text-gold flex items-center gap-2">
            <Scale className="w-3 h-3" /> Legal · Información general
          </span>
          <h1 className="font-serif-display text-4xl md:text-5xl leading-tight mt-3">Aviso Legal</h1>
          <p className="text-muted-foreground mt-4 max-w-2xl">
            Información legal sobre el titular del sitio web relevo.global y de la plataforma Relevo, y condiciones generales de acceso.
          </p>
        </div>

        <div className="hairline bg-card">
          {SECTIONS.map((s, i) => (
            <section key={i} className={`grid md:grid-cols-12 gap-4 px-6 md:px-8 py-7 ${i > 0 ? "hairline-t" : ""}`} data-testid={`legal-section-${i + 1}`}>
              <div className="md:col-span-4">
                <span className="font-mono-label text-[#E0712C]">{String(i + 1).padStart(2, "0")}</span>
                <h2 className="font-serif-display text-xl leading-tight mt-1">{s.title}</h2>
              </div>
              <div className="md:col-span-8 space-y-3">
                {s.paragraphs.map((t, j) => (
                  <p key={j} className="text-sm md:text-base text-muted-foreground leading-relaxed">{t}</p>
                ))}
                {s.dl && (
                  <dl className="grid sm:grid-cols-[180px_1fr] gap-y-2 gap-x-4 text-sm">
                    {s.dl.map(([k, v]) => (
                      <div key={k} className="contents">
                        <dt className="font-mono-label text-muted-foreground">{k}</dt>
                        <dd className="text-foreground">{v}</dd>
                      </div>
                    ))}
                  </dl>
                )}
              </div>
            </section>
          ))}
        </div>

        <p className="font-mono-label text-muted-foreground mt-8">Última actualización: junio de 2026</p>
      </div>
    </Layout>
  );
}
